/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_Account_LabelInputs */

const es_privacy_policy_retention_account_label = /** @type {(inputs: Privacy_Policy_Retention_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacion de Cuenta`)
};

const en_privacy_policy_retention_account_label = /** @type {(inputs: Privacy_Policy_Retention_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Information`)
};

/**
* | output |
* | --- |
* | "Account Information" |
*
* @param {Privacy_Policy_Retention_Account_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_account_label = /** @type {((inputs?: Privacy_Policy_Retention_Account_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_Account_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_account_label(inputs)
	return en_privacy_policy_retention_account_label(inputs)
});
export { privacy_policy_retention_account_label as "privacy_policy.retention.account_label" }